import React, {useState} from "react";
import {Button, Col, Container, Row} from "react-bootstrap";
import Sidebar from "./Sidebar";
import './../../../../styles/adminPanel.css';
import {Link, useNavigate} from "react-router-dom";
import {getUserInfo, wyloguj} from "../../../../GlobalServices";

export interface LayoutProps {
    children: React.ReactNode;
    label?: string;
}

const AdminPanelLayaut = ({children, label}: LayoutProps) => {
    // const navigate = useNavigate();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const onClickWyloguj = () => {
        wyloguj();
        // navigate('/');
        // window.location.reload();
    }

    return (
        <Container fluid className={'adminPanel'}>
            <Row>
                <Sidebar show={show} handleClose={handleClose}/>
                <Col className="p-0">
                    <div className="flex-row d-flex p-3 m-0 side-header-wrapper align-items-center justify-content-between">
                        <Button variant="primary" onClick={handleShow} className="d-lg-none">
                            Menu
                        </Button>
                        <div className="d-flex flex-row align-items-center d-lg-block">{label}</div>
                        <div className="d-flex flex-row align-items-center">
                            {getUserInfo()?.uzytkownik?.username}
                            <div className="divider" />
                            <Button size={'sm'} variant={'outline-danger'} onClick={onClickWyloguj}>Wyloguj</Button>
                        </div>
                    </div>
                    <div className={'p-3'}>
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default AdminPanelLayaut;
